import { ControlledDatePicker } from '@@viewCommonComponents/controlled';
import { isNil, propOr } from 'ramda';
import { isoToFr } from '@@viewHelpers/date.js';
import { Button, Icon, InfoMessage, InfoTooltip, Tag } from '@fasstech/middle-design-system';
import classNames from 'classnames';
import { dateEligibility } from '@@serverHelpers/index.mjs';

const AddGrantee = ({
  title,
  buttonTitle,
  icon,
  infoTooltip,
  grantees,
  addGrantee,
  deleteGrantee,
  setEditingGrantee,
  granteeHasBirthDate,
  form,
  minBirthDate,
  maxBirthDate,
  isMaxCountReached,
  maxCountMessage,
  formName,
  dataTestId,
  getMiddleText
}) => {
  const isChild = formName !== 'spouse';

  return (
    <div className="border border-[#CBCCCD] rounded-md w-full max-w-md mb-4">
      <div className="flex items-center p-2 border border-b-[#CBCCCD]">
        <Icon className="mr-3" strokeClassName="bg-secondary" name={icon} size={24}></Icon>
        <div className="flex items-center text-secondary text-2xl font-bold">
          <span className="pr-2 pb-1">{title}</span>
          <InfoTooltip text={infoTooltip} />
        </div>
      </div>
      <div className={'p-4'}>
        <div className="flex flex-col">
          {grantees.map((grantee, index) => {
            const isEditing = propOr(false, 'editing', grantee);
            const eligibility = propOr(false, 'birthDate', grantee)
              ? dateEligibility(grantee.birthDate, minBirthDate, maxBirthDate)
              : {};

            return (
              <>
                {!isNil(grantee) && (
                  <div key={index} className="p-4">
                    <div
                      className={
                        'bg-[#F2F6F9] rounded-lg mb-2 p-2 flex items-center justify-between'
                      }>
                      {isChild ? (
                        <>
                          <div className="font-bold mb-2">Enfant {index + 1}</div>
                          <Tag label={eligibility.label} variant={eligibility.variant} />
                        </>
                      ) : (
                        <div className="bg-[#F2F6F9] font-bold">Conjoint</div>
                      )}
                    </div>

                    <div className="flex justify-between">
                      {isEditing ? (
                        <ControlledDatePicker
                          name={isChild ? `${formName}.${index}.birthDate` : 'spouse.birthDate'}
                          form={form}
                          minDate={isChild ? null : minBirthDate?.toDate()}
                          maxDate={isChild ? new Date() : maxBirthDate?.toDate()}
                          className={'w-[90%]!'}
                          data-testid={`${dataTestId}BirthDate`}
                        />
                      ) : (
                        <>
                          <span>{getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_LABEL')}</span>
                          <span className="pr-4">{isoToFr(grantee.birthDate)}</span>
                        </>
                      )}
                      <div className="flex items-center">
                        {!isEditing && (
                          <Icon
                            className="cursor-pointer mr-2"
                            name="pen"
                            onClick={() =>
                              isChild ? setEditingGrantee(true, index) : setEditingGrantee(true)
                            }
                            data-testid={`edit${dataTestId}`}
                          />
                        )}
                        <Icon
                          className="cursor-pointer"
                          name="delete"
                          onClick={() => (isChild ? deleteGrantee(index) : deleteGrantee())}
                          data-testid={`delete${dataTestId}`}
                        />
                      </div>
                    </div>

                    {isEditing && (
                      <Button
                        className="mt-4 p-2 w-full rounded-lg"
                        onClick={() => {
                          if (isChild) {
                            setEditingGrantee(false, index);
                          } else {
                            setEditingGrantee(false);
                          }
                          form.trigger();
                        }}
                        disabled={isChild ? !granteeHasBirthDate(index) : !granteeHasBirthDate}
                        data-testid={`validate${dataTestId}`}>
                        Valider
                      </Button>
                    )}
                  </div>
                )}
              </>
            );
          })}
        </div>
        {!isMaxCountReached && (
          <Button
            variant="text"
            icon="plus"
            onClick={addGrantee}
            disabled={isMaxCountReached}
            className={classNames({
              'cursor-not-allowed opacity-70': isMaxCountReached
            })}
            data-testid={`add-${dataTestId}`}>
            <span className="font-bold">{buttonTitle}</span>
          </Button>
        )}
        <InfoMessage isDisplayed={isMaxCountReached}>{maxCountMessage}</InfoMessage>
      </div>
    </div>
  );
};

export default AddGrantee;
